
$(function () {
    (function() {
        var DOM = {
            supplierBox: $('#supplier'),
            fillinBox: $('#fillin_box'),
            fillinShpperBox: $('#fillin_shoper_box'),
            updateShopBox: $('#update-box'),
            upgradeShopBox: $('#upgrade-box'),
            countryBox: $('#country')
        }
        if(DOM.supplierBox.length) {
            loadJs('/themes/mall/default/js/min/apply-util.js');
            var systemSwiper = new Swiper('.swiper-container',{
                loop:true,
                speed: 500,
                // autoplay: 3000,
                grabCursor: true,
                onSlideChangeStart:function(e) {
                    let idx = e.activeIndex - 1
                    idx = idx === 4 ? 0 : idx
                    $('.system .btns .btn-item').eq(idx).addClass('btn-active').siblings().removeClass('btn-active')
                }
            })
            $('.tab-wrap').on('click', '.tab-item', function() {
                const type = $(this).attr('type')
                type && $('html, body').animate({
                    scrollTop: $(`.${type}`).offset().top - 100
                }, 500)
                $(this).addClass('active').siblings().removeClass('active')
            })
            // $('.btn-2').on('click', function () {
            //     $.ajax({
            //         url: jkas.url('/supplier/check'),
            //         type: 'post',
            //         dataType: 'json',
            //         success: function (res) {
            //             const code = res.code;
            //             // 2021/12/14 把登录提示改为跳转登录
            //             if(-3 === code) {
            //                 location.href = jkas.url('/login');
            //             }  else if (res.code == 22) {
            //                 sessionStorage.setItem('applyParams', JSON.stringify({
            //                     apply_type: 0,
            //                     isShoper_in: false // 是否是店长入驻 默认是商家入驻
            //                 }))
            //                 location.href = jkas.url('/supplier/choose')
            //             } else if (res.code == 10) {
            //                 // 如果返回审核不通过则走缓存
            //                 if (res.data.status == 2) {
            //                     localStorage.setItem('shop_data', JSON.stringify(res.shop_data))
            //                     location.href = jkas.url('/supplier/submit.htm?type=' + (res.data.type_id == 0 ? 1 : 2) + '&status=' + res.data.status)
            //                 } else {
            //                     localStorage.clear();
            //                     location.href = jkas.url('/supplier/submit.htm?type=' + (res.data.type_id == 0 ? 1 : 2) + '&status=' + res.data.status)
            //                 }
            //             } else {
            //                 layer.msg(res.rep_msg);
            //             }
            //         },
            //     })
            // })
            $('.swiper-container').mousemove(function () {
                systemSwiper.stopAutoplay()
            })
            $('.swiper-container').mouseleave(function () {
                systemSwiper.startAutoplay()
            })
            $('.system .btns .btn-item').mouseenter(function(e) {
                const { index } = e.target.dataset || e.srcElement.dataset
                if(!index) return
                systemSwiper.swipeTo(+index, 500)
            })
        } else if(DOM.fillinBox.length) {
            console.log('暂不抽离')
        } else if(DOM.fillinShpperBox.length) {
            loadJs('/themes/mall/default/js/min/supller-fillin_shoper.js');
        } else if(DOM.updateShopBox.length) {
            loadJs('/themes/mall/default/js/min/shop-change.js');
        } else if(DOM.upgradeShopBox.length) {
            loadJs('/themes/mall/default/js/min/shop-upgrade.js');
        }
        
        else if(DOM.countryBox.length) {
            if (location.pathname === jkas.url('/supplier')) {
                return
            }
            if (location.pathname !== jkas.url('/supplier/enter')) {
                $('#province,#city,#district').show()
            }
            var country_id = '',
                district_id = '',
                province_id = '',
                city_id = ''
            if ($('#country')) {
                country_id = $('#country').data().value
                province_id = $('#province').data().value
                city_id = $('#city').data().value
                district_id = $('#district').data().value
            }
        
        
            if (
                country != '' &&
                province_id != '' &&
                district_id != '' &&
                city_id != ''
            ) {
                var el = ['.aaa']
                var country_ops = $('#country option')
                for (var i = 0; i < country_ops.length; i++) {
                    if (country_ops[i].value == country_id) {
                        $(country_ops[i]).prop('selected', 'ture')
                    }
                }
        
                _ajax(country_id, el, function (data) {
                    fn_html(data, '#province')
                    var ops = $('#province option')
                    for (var i = 0; i < ops.length; i++) {
                        if (ops[i].value == province_id) {
                            $(ops[i]).prop('selected', 'ture')
                        }
                    }
                })
                _ajax(province_id, el, function (data) {
                    fn_html(data, '#city')
                    var ops = $('#city option')
                    for (var i = 0; i < ops.length; i++) {
                        if (ops[i].value == city_id) {
                            $(ops[i]).prop('selected', 'ture')
                        }
                    }
                })
                _ajax(city_id, el, function (data) {
                    fn_html(data, '#district')
                    var ops = $('#district option')
                    for (var i = 0; i < ops.length; i++) {
                        if (ops[i].value == district_id) {
                            $(ops[i]).prop('selected', 'ture')
                        }
                    }
                })
            }
            $('#country').on('change', function () {
                //发送国家id - 获取省份
                $('#province').show()
                var val = $(this).val()
                var el = ['#province', '#city', '#district']
                _ajax(val, el, function (data) {
                    fn_html(data, '#province')
                })
            })
            $('#province').on('change', function () {
                //省份
                $('#city').show()
                var val = $(this).find('option:selected').data('val')
                var el = ['#city', '#district']
                _ajax(val, el, function (data) {
                    fn_html(data, '#city')
                })
            })
            $('#city').on('change', function () {
                $('#district').show()
                var val = $(this).find('option:selected').data('val')
                var el = ['#district']
                _ajax(val, el, function (data) {
                    fn_html(data, '#district')
                })
            })
            function _ajax(val, el, cb) {
                var _html = "<option value=''>" + JL.ple_sel + '</option>' //请选择
                if (val === JL.ple_sel) {
                    for (var i = 0; i < el.length; i++) {
                        $(el[i]).html(_html)
                    }
                } else {
                    $(el[el.length - 1]).html(_html)
                    $.ajax({
                        url: jkas.url(getUrlSearch('type') == 1 ? '/wxxcx/areaLinkXcx' : '/wxxcx/areaLinkOverseasXcx'),
                        type: 'post',
                        dataType: 'json',
                        data: { code: val },
                        success: function (data) {
                            cb(data)
                        },
                    })
                }
            }
            function fn_html(data, el) {
                var html = "<option value=''>" + JL.ple_sel + '</option>'
                for (var i = 0; i < data.list.length; i++) {
                    html +=
                        '<option value="' +
                        data.list[i].area_id +
                        '" data-val="' +
                        data.list[i].code +
                        '">' +
                        data.list[i].area_name +
                        '</option>'
                }
                $(el).html(html)
            }
        }
    })();
	// $('.step_1,.circle_2').addClass('act')
	// $('.step_2,.circle_3').addClass('act')
	// $('.text_box span').eq(1).addClass('text_active')
	// $('.text_box span').eq(2).addClass('text_active')
	// if (getUrlSearch('sup_id')) {
	// 	$('.agree1_top').append('<span>（如无，可不填）</span>')
	// 	$('.agree1_top').eq(1).children('span').text('（均必填）')
	// 	$('.agree_wapper').eq(1).siblings().find('i').remove()
	// 	$('.agree_wapper').eq(1).find('.agree1_box').eq(1).find('i').remove()
	// 	$('input[name=shop_tel],input[name=shop_email],input[name=shop_scale]')
	// 		.parent()
	// 		.remove()
	// 	$('input[name=clt_nm]')
	// 		.siblings('span')
	// 		.html('<i style="color:#e75d5d">*</i>申请人姓名：')
	// 	$('select[name=clt_cdtp]')
	// 		.siblings('span')
	// 		.html('<i style="color:#e75d5d">*</i>申请人证件类型：')
	// 	$('input[name=clt_cdno]')
	// 		.siblings('span')
	// 		.html('<i style="color:#e75d5d">*</i>申请人证件号：')
	// 	$('input[name=supplier_name]')
	// 		.siblings('span')
	// 		.html('<i style="color:#e75d5d">*</i>店铺名称：')
	// 	$('input[name=kd]').parents('.box_l_line').remove()
	// }
})
// $(function () {
// 	var pathname = location.pathname
// 	$('#cooperation .coo-header .tab-box')
// 		.on('mouseenter', '.tab', function () {
// 			$(this).addClass('tabhv')
// 		})
// 		.on('mouseleave', '.tab', function () {
// 			$(this).removeClass('tabhv')
// 		})
// 	// 入驻资质选项卡
// 	$('#cooperation .coo-main .m-3 .tabs').on('mouseenter', '.tab', function () {
// 		$(this).addClass('active').siblings().removeClass('active')
// 		var i = $(this).index()
// 		var tabs = $('#cooperation .coo-main .m-3 .tab-box .tab')
// 		tabs.eq(i).addClass('active').siblings().removeClass('active')
// 	})
// 	myBanner()
// 	if (pathname.indexOf('supplier') == 1) {
// 		bindSelectbank()
// 	}
// 	// 提交商家入驻资料
// 	$('#submit').click(function () {
// 		console.log($('form').serialize())
// 	})
	
// })


$(function () {
	$('.agree1_last_l').click(function () {
		$(this).parents('.agree_wapper').hide()
		$(this).parents('.agree_wapper').prev().css('display', 'block')
	})
	$('.last_r_final').click(function () {
		var list = $(this)
			.parent('.agree1_last')
			.siblings('.agree1_box')
			.children()
			.find('input')
		for (var i = 0; i < list.length; i++) {
			if ($(list[i]).parent().find('i').length >= 1) {
				if ($(list[i]).val() == '') {
					layer.msg('请填写' + $(list[i]).parent().find('.item-name').text())
					return false
				}
			}
		}
		$(this)
			.parents('.agree_wapper')
			.siblings('.text_box')
			.children('.text_box span')
			.addClass('text_active')
		$(this)
			.parents('.agree_wapper')
			.siblings('.step_box')
			.children('.step_2')
			.css('background-color', '#ec3136')
		$(this)
			.parents('.agree_wapper')
			.siblings('.step_box')
			.children('.step_2')
			.children()
			.css('background-color', '#ec3136')
		let url =
			location.href.indexOf('update') != -1
				? '/supplier/update'
				: '/supplier/add',
			formArr = (getUrlSearch('type') == 1) ? [...$('#xinxi').serializeArray(), ...$('#shoukuan').serializeArray()] : $('#xinxi').serializeArray(),
			type = location.href.indexOf('sup_id') == -1 ? 0 : 1
		formArr.push({ name: 'type', value: type })
		location.href.indexOf('sup_id') != -1
			? formArr.push({ name: 'sup_id', value: getUrlSearch('sup_id') })
			: ''
		console.log(formArr);

		// location.href = getUrlSearch('sup_id') ? 'distribution_check.htm?sup_id=' + getUrlSearch('sup_id') + '&type=' + getUrlSearch('type') : 'distribution_check.htm?type=' + getUrlSearch('type');

		$.ajax({
			url: jkas.url(url),
			type: 'post',
			dataType: 'json',
			data: formArr,
			success: function (res) {
				layer.msg(res.rep_msg)
				if (res.code == 10) {
					location.href.indexOf('sup_id') == -1
						? (location.href = jkas.url('/supplier/check'))
						: (location.href =
							jkas.url('/supplier/distribution_check') +
							'?way=1&sup_id=' +
							getUrlSearch('sup_id') + '&type=' + getUrlSearch('type'))
				}
			},
		})
	})
	$('input[name="sa_id"]').click(function () {
		$('input[name="attr_name"]').remove()
		if ($(this).val() == 0) {
			$(this)
				.parent()
				.after(
					'<input type="text" name="attr_name" placeholder="填写类型" stylle="float:inherit;">'
				)
		}
		// $(this).parents('.box_select').siblings('#stall_name').remove();
		if ($(this).val() == '5') {
			$('.pf').show()
			// $(this).parents('.box_select').after('<div class="box_l_line" id="stall_name"><span>档口名：</span><input type="text" name="stall_name"></div>')
		} else {
			$('.pf').hide()
		}
	})
	$('.agree1_last_r').on('click', function () {
		_detection($(this))
	})

	// 企业打款资料填写点击下一步
	$('.qiye_xyb').click(function () {
		_detection($(this))
	})
	// 个人打款资料填写点击下一步
	$('.geren_xyb').click(function () {
		_detection($(this))
	})
	// 打款验证银行账号点击下一步
	$('.qysk1_tijiao').click(function () {
		_detection($(this))
	})
	// 个人收款点击获取验证码
	// 设置时间循环
	let codeTimeNum = 60
	let clickStatus = true //防重复点击
	$('.yzm').click(function () {
		if (clickStatus) {
			if (
				$('select[name="bkacc_bkid"]').val() == '' ||
				$('select[name="clt_kd"]').val() == '' ||
				$('select[name="bkacc_prcnm"]').val() == '' ||
				$('select[name="bkacc_prcnm"] option:selected').text() == '' ||
				$('select[name="bkacc_citynm"]').val() == '' ||
				$('select[name="bkacc_citynm"] option:selected').text() == '' ||
				$('.gr_clt_nm').val() == '' ||
				$('input[name="clt_cdno"]').val() == '' ||
				$('input[name="bkacc_accno"]').val() == '' ||
				$('input[name="clt_email"]').val() == '' ||
				$('input[name="bkacc_openbknm"]').val() == '' ||
				$('input[name="bkacc_openbkcd"]').val() == '' ||
				$('input[name="clt_addr"]').val() == '' ||
				$('input[name="clt_mobno"]').val() == ''
			) {
				layer.msg('请填写必填项!')
				return
			}
			clickStatus = false
			var openData = [
				{ name: 'fcflg', value: 1 },
				{ name: 'bkacc_bkid', value: $('select[name="bkacc_bkid"]').val() },
				{ name: 'clt_kd', value: $('select[name="clt_kd"]').val() },
				{ name: 'bkacc_prccd', value: $('select[name="bkacc_prcnm"]').val() },
				{ name: 'bkacc_prcnm', value: $('select[name="bkacc_prcnm"] option:selected').text() },
				{ name: 'bkacc_citynm', value: $('select[name="bkacc_citynm"]').val() },
				{ name: 'bkacc_citycd', value: $('select[name="bkacc_citynm"] option:selected').text() },
				{ name: 'clt_nm', value: $('.gr_clt_nm').val() },
				{ name: 'clt_cdno', value: $('input[name="clt_cdno"]').val() },
				{ name: 'bkacc_accno', value: $('input[name="bkacc_accno"]').val() },
				{ name: 'clt_email', value: $('input[name="clt_email"]').val() },
				{ name: 'bkacc_openbknm', value: $('input[name="bkacc_openbknm"]').val() },
				{ name: 'bkacc_openbkcd', value: $('input[name="bkacc_openbkcd"]').val() },
				{ name: 'clt_addr', value: $('input[name="clt_addr"]').val() },
				{ name: 'clt_mobno', value: $('input[name="clt_mobno"]').val() },
			]

			$.ajax({
				url: jkas.url('/pay/openShopsCardXcx'),
				type: 'post',
				dataType: 'json',
				data: openData,
				success: function (res) {
					if (res.code == 0) {
						if (codeTimeNum == 60) {
							var codeTimes = setInterval(codeTime, 1000);
							function codeTime() {
								codeTimeNum--
								$('.yzm').text('获取验证码(' + codeTimeNum + ')')
								if (codeTimeNum == 0) {

									clearInterval(codeTimes)
									$('.yzm').text('获取验证码')
									setTimeout(() => {
										codeTimeNum = 60
										clickStatus = true
									}, 200);
								}
							}
						}
					} else {
						layer.msg(res.rep_msg)
					}

				},
			})

		}


	})

	function _detection(that) {
		let openShopsData = []
		var list = that
			.parent('.agree1_last')
			.siblings('.agree1_box')
			.children()
			.find('input')
		for (var i = 0; i < list.length; i++) {
			openShopsData[i] = {
				name: $(list[i]).attr('name'),
				value: $(list[i]).val()
			}
			if ($(list[i]).parent().find('i').length >= 1) {
				if ($(list[i]).val() == '') {
					layer.msg('请填写' + $(list[i]).parent().find('.item-name').text())
					return false
				}
			}
		}

		var sel = that
			.parent('.agree1_last')
			.siblings('.agree1_box')
			.children()
			.find('select option:selected')

		for (var i = 0; i < sel.length; i++) {
			openShopsData.push({ name: $(sel[i]).attr('name'), value: $(sel[i]).val() })
			if (
				sel[i].value == '' &&
				$(sel[i]).parents('.box_l_line').find('i').length >= 1
			) {
				layer.msg(JL.com_adrress + '！')
				return false
			}
		}


		if (that.attr('class') == 'agree1_last_r txzl_xyb') {
			layer.confirm(
				'请确认填写无误后，点击确认按钮前往下一步操作', {
				title: '提示',
				btn: ['是', '否'],
			}, function (index) {
				$.ajax({
					url: jkas.url('/supplier/glpayOn'),
					type: 'post',
					dataType: 'json',
					success: function (data1) {
						if (data1.code == '-7') {//未开户绑卡,正常流程走下去
							$.ajax({
								url: jkas.url('/pay/getOpenShopsCardMessage'),
								type: 'post',
								dataType: 'json',
								success: function (data2) {
									// 如果是0，则说明填过资料，否则就正常操作
									// 判断是企业还是个人，kd = 0 个人去设置密码，kd = 1 企业去下一个接口验证，通过则直接去打款验证，不通过就留在企业打款资料填写页面
									if (data2.code == 0) {
										if (data2.data.kd && data2.data.kd == 1) {
											$.ajax({
												url: jkas.url('/pay/bindMessageExistXcx'),
												type: 'post',
												dataType: 'json',
												success: function (data3) {
													layer.close(index)
													if (data3.code == 0) {//是0，表示成功，进入打款验证，赋值银行卡号
														$(that).parents('.agree_wapper').hide()
														$('.tjsh').css('display', 'block')
														$('.qysk').hide()
														$('.sklxxz').hide()
														$('.grsk').hide()
														$('.qysk2').hide()
														$('.qysk3').hide()
														$('.dkyz').show()
														$('.qysk1').show()
														$('.card_num').val(data.acc_no)
													} else {//否则留在打款信息填写页面
														$(that).parents('.agree_wapper').hide()
														$('.tjsh').css('display', 'block')
														$('.sklxxz').hide()
														$('.grsk').hide()
														$('.qysk2').hide()
														$('.qysk3').hide()
														$('.dkyz').hide()
														$('.qysk1').hide()
														$('.sklx').show()
														$('.qysk').show()
														// 这里要进行赋值
														$('.qy_clt_cdno').val(data2.data.clt_cdno)
														$('#clt_cdtp').val(data2.data.clt_cdtp)
														$('select[name="clt_cdtp"]').val(data2.data.clt_cdtp)
														$("input[name='clt_bslic']").val(data2.data.clt_bslic)
														$("input[name='clt_cdno']").val(data2.data.clt_cdno)

													}
												},
											})
										} else {
											layer.close(index)
											$('.sklxxz').show()
											$('.step_3,.circle_4').addClass('act')
											$('.text_box span').eq(3).addClass('text_active')
											$(that).parents('.agree_wapper').hide()
											$('.tjsh').css('display', 'block')
											$('.sklxxz').hide()
											$('.qysk2').hide()
											$('.qysk3').hide()
											$('.dkyz').hide()
											$('.qysk1').hide()
											$('.sklx').show()
											$('.grsk').show()
											// 这里要进行赋值
											$('.gr_clt_nm').val(data2.data.clt_nm)
											$('.gr_clt_cdno').val(data2.data.clt_cdno)
											$("input[name='clt_nm']").val(data2.data.clt_nm)
											$("input[name='clt_cdno']").val(data2.data.clt_cdno)
										}
									} else {
										layer.close(index)
										$('.sklxxz').show()
										$('.step_3,.circle_4').addClass('act')
										$('.text_box span').eq(3).addClass('text_active')
										that.parents('.agree_wapper').hide()
										that.parents('.agree_wapper').next().css('display', 'block')
									}
								},
							})
						} else if (data1.code == '10') {//以开户绑卡,直接到结束，提交信息
							layer.close(index)
							$(that).parents('.agree_wapper').hide()
							$('.tjsh').css('display', 'block')
							$('.qysk').hide()
							$('.grsk').hide()
							$('.qysk1').hide()
							$('.qysk2').hide()
							$('.qysk3').show()
						} else if (data1.code == '-11') { //未设置支付密码,跳转到设置支付密码
							layer.close(index)
							$(that).parents('.agree_wapper').hide()
							$('.zfmm').css('display', 'block')
							$('.qysk').hide()
							$('.grsk').hide()
							$('.qysk1').hide()
							$('.qysk2').show()
						} else {
							layer.close(index)
							layer.msg(data.rep_msg)
						}
					},
				})
			});
		} else if (that.attr('class') == 'agree1_last_r txzl_xyb_hw') {//以开户绑卡,直接到结束，提交信息
			layer.confirm(
				'请确认填写无误后，点击确认按钮进行提交审核', {
				title: '提示',
				btn: ['是', '否'],
			}, function (index) {
				layer.close(index)
				location.href = getUrlSearch('sup_id') ? 'distribution_check.htm?sup_id=' + getUrlSearch('sup_id') + '&type=' + getUrlSearch('type') : 'distribution_check.htm?type=' + getUrlSearch('type');
			});

		} else if (that.attr('class') == 'shxx_r qiye_xyb') {

			openShopsData.forEach((item, index) => {
				if (item.name == "bkacc_openbkcd") {
					if (item.value == '') {
						layer.msg('请输入开户支行号！')
						return
					}
				}
				if (item.name == "bkacc_openbknm") {
					if (item.value == '') {
						layer.msg('请输入开户支行名称！')
						return
					}
				}
			})
			openShopsData.push(
				{ name: 'fcflg', value: 1 },
				{ name: 'bkacc_prcnm_qy', value: $('select[name="bkacc_prcnm_qy"] option:selected').text() },
				{ name: 'bkacc_citycd', value: $('select[name="bkacc_citynm_qy"] option:selected').text() }
			)

			layer.confirm(
				'请确认填写无误后，点击确认按钮前往下一步进行打款验证', {
				title: '提示',
				btn: ['是', '否'],
			}, function (index) {
				$.ajax({
					url: jkas.url('/pay/openShopsCardXcx'),
					type: 'post',
					dataType: 'json',
					data: openShopsData,
					success: function (data) {
						if (data.code == 0) {
							$(that).parents('.agree_wapper').hide()
							$(that).parents('.agree_wapper').next().css('display', 'block')
							$('.qysk').hide()
							$('.grsk').hide()
							$('.dkyz').show()
							$('.qysk1').show()
							layer.close(index)
							for (var i = 0; i < list.length; i++) {
								if ($(list[i]).parent().find('i').length >= 1) {
									if ($(list[i].name).selector == 'bkacc_accno') {
										$('.card_num').val($(list[i]).val())
									}
								}
							}
						} else {
							layer.msg(data.rep_msg)
						}
					},
				})
			});
		} else if (that.attr('class') == 'shxx_r geren_xyb') {
			$.ajax({
				url: jkas.url('/pay/activationXcx'),
				type: 'post',
				dataType: 'json',
				data: {
					actiinfo: $('input[name="actiinfo_num"]').val()
				},
				success: function (res) {
					if (res.code == 0) {
						$(that).parents('.agree_wapper').hide()
						$('.zfmm').css('display', 'block')
						$('.qysk').hide()
						$('.grsk').hide()
						$('.qysk1').hide()
						$('.qysk2').show()
					} else {
						layer.msg(res.rep_msg)
					}
				},
			})
		} else if (that.attr('class') == 'shxx_r qysk1_tijiao') {
			$.ajax({
				url: jkas.url('/pay/activationXcx'),
				type: 'post',
				dataType: 'json',
				data: {
					actiinfo: $('input[name="actiinfo"]').val()
				},
				success: function (res) {
					if (res.code == 0) {
						$(that).parents('.agree_wapper').hide()
						$(that).parents('.agree_wapper').next().css('display', 'block')
						$('.qysk').hide()
						$('.grsk').hide()
						$('.qysk1').hide()
						$('.qysk2').show()
					} else {
						layer.msg(res.rep_msg)
					}
				},
			})
		} else {
			that.parents('.agree_wapper').hide()
			that.parents('.agree_wapper').next().css('display', 'block')
		}

	}
})
$(function () {
	var inputs = $(':file')
	var result, div
	$(inputs).on('click', function () {
		if (typeof FileReader === 'undefined') {
			result.innerHTML = '' + JL.sorry + '，' + JL.yours + ' FileReader' //抱歉，你的浏览器不支持FileReader
			this.setAttribute('disabled', 'disabled')
		} else {
			this.addEventListener('change', readFile, false)
		}
	})
	function readFile() {
		var input = this
		var img = $(this).next('div').children('img')
		for (var i = 0; i < this.files.length; i++) {
			if (!input['value'].match(/.jpg|.png|/i)) {
				//判断上传文件格式
				return alert('' + JL.un_ture + '，' + JL.ple_upd + '')
			}
			var reader = new FileReader()
			reader.readAsDataURL(this.files[i])
			reader.onload = function (e) {
				var that = this
				$.ajax({
					url: jkas.url('/supplier/upload'),
					type: 'post',
					contenType: 'image/tiff',
					data: { pic: that.result },
					success: function (data) {
						$(input).siblings('.i_hidden').val(data)
					},
				})
				$(img).attr('src', this.result)
				$(img).attr('style', 'z-index: 111;')
				$(img).show()
			}
		}
	}
})
$(function () {
	$('.time').change(function () {
		if ($(this).find('option:selected').text() == '' + JL.geli_turn + '') {
			$(this).parents('.box_select').siblings('.box_selectl').hide()
			$('.box_selectl1').show()
		} else {
			$('.box_selectl1').hide()
			$(this).parents('.box_select').siblings('.box_selectl').show()
		}
	})
})
$(function () {
	// if (location.pathname === jkas.url('/supplier')) {
	// 	return
	// }
	// if (location.pathname !== jkas.url('/supplier/enter')) {
	// 	$('#province,#city,#district').show()
	// }
	// var country_id = '',
	// 	district_id = '',
	// 	province_id = '',
	// 	city_id = ''
	// if ($('#country')) {
	// 	country_id = $('#country').data().value
	// 	province_id = $('#province').data().value
	// 	city_id = $('#city').data().value
	// 	district_id = $('#district').data().value
	// }


	// if (
	// 	country != '' &&
	// 	province_id != '' &&
	// 	district_id != '' &&
	// 	city_id != ''
	// ) {
	// 	var el = ['.aaa']
	// 	var country_ops = $('#country option')
	// 	for (var i = 0; i < country_ops.length; i++) {
	// 		if (country_ops[i].value == country_id) {
	// 			$(country_ops[i]).prop('selected', 'ture')
	// 		}
	// 	}

	// 	_ajax(country_id, el, function (data) {
	// 		fn_html(data, '#province')
	// 		var ops = $('#province option')
	// 		for (var i = 0; i < ops.length; i++) {
	// 			if (ops[i].value == province_id) {
	// 				$(ops[i]).prop('selected', 'ture')
	// 			}
	// 		}
	// 	})
	// 	_ajax(province_id, el, function (data) {
	// 		fn_html(data, '#city')
	// 		var ops = $('#city option')
	// 		for (var i = 0; i < ops.length; i++) {
	// 			if (ops[i].value == city_id) {
	// 				$(ops[i]).prop('selected', 'ture')
	// 			}
	// 		}
	// 	})
	// 	_ajax(city_id, el, function (data) {
	// 		fn_html(data, '#district')
	// 		var ops = $('#district option')
	// 		for (var i = 0; i < ops.length; i++) {
	// 			if (ops[i].value == district_id) {
	// 				$(ops[i]).prop('selected', 'ture')
	// 			}
	// 		}
	// 	})
	// }
	// $('#country').on('change', function () {
	// 	//发送国家id - 获取省份
	// 	$('#province').show()
	// 	var val = $(this).val()
	// 	var el = ['#province', '#city', '#district']
	// 	_ajax(val, el, function (data) {
	// 		fn_html(data, '#province')
	// 	})
	// })
	// $('#province').on('change', function () {
	// 	//省份
	// 	$('#city').show()
	// 	var val = $(this).find('option:selected').data('val')
	// 	var el = ['#city', '#district']
	// 	_ajax(val, el, function (data) {
	// 		fn_html(data, '#city')
	// 	})
	// })
	// $('#city').on('change', function () {
	// 	$('#district').show()
	// 	var val = $(this).find('option:selected').data('val')
	// 	var el = ['#district']
	// 	_ajax(val, el, function (data) {
	// 		fn_html(data, '#district')
	// 	})
	// })
	// function _ajax(val, el, cb) {
	// 	var _html = "<option value=''>" + JL.ple_sel + '</option>' //请选择
	// 	if (val === JL.ple_sel) {
	// 		for (var i = 0; i < el.length; i++) {
	// 			$(el[i]).html(_html)
	// 		}
	// 	} else {
	// 		$(el[el.length - 1]).html(_html)
	// 		$.ajax({
	// 			url: jkas.url(getUrlSearch('type') == 1 ? '/wxxcx/areaLinkXcx' : '/wxxcx/areaLinkOverseasXcx'),
	// 			type: 'post',
	// 			dataType: 'json',
	// 			data: { code: val },
	// 			success: function (data) {
	// 				cb(data)
	// 			},
	// 		})
	// 	}
	// }
	// function fn_html(data, el) {
	// 	var html = "<option value=''>" + JL.ple_sel + '</option>'
	// 	for (var i = 0; i < data.list.length; i++) {
	// 		html +=
	// 			'<option value="' +
	// 			data.list[i].area_id +
	// 			'" data-val="' +
	// 			data.list[i].code +
	// 			'">' +
	// 			data.list[i].area_name +
	// 			'</option>'
	// 	}
	// 	$(el).html(html)
	// }
})
var myBanner = function () {
	var container = $('#cooperation .coo-main .m-4 .container')
	var prev = container.find('.prev-btn')
	var next = container.find('.next-btn')
	var wrapper = container.find('.wrapper')
	var lis = container.find('.wrapper li')
	var uls = container.find('.wrapper ul')
	var lthide = { width: 285, height: 150, top: 55, left: -400 }
	var json0 = { width: 285, height: 150, top: 55, left: 0 }
	var json1 = { width: 405, height: 215, top: 25, left: 330 }
	var json2 = { width: 285, height: 150, top: 55, left: 775 }
	var rthdie = { width: 285, height: 150, top: 55, left: 1160 }
	var timer = null
	var time = 2000
	Interval()
	function Interval() {
		timer = setInterval(function () {
			moveNext()
		}, time)
	}
	next.click(function () {
		moveNext()
	})
	prev.click(function () {
		movePrev()
	})
	container
		.on('mouseenter', function () {
			clearInterval(timer)
		})
		.on('mouseleave', function () {
			Interval()
		})
	function moveNext() {
		$('.none').css(rthdie)
		if (!lis.is(':animated')) {
			var lt = $('.no0')
			var ct = $('.no1')
			var rt = $('.no2')
			if (!lis.is(':animated')) {
				ct.animate(json0, 400)
				rt.animate(json1, 400)
				lt.animate(lthide, 400, function () {
					lt.css(json2)
					lt.attr('class', 'none')
				})
				ct.attr('class', 'no0')
				rt.attr('class', 'no1')
				if ($('.no1').next().length != 0) {
					$('.no1').next().attr('class', 'no2')
				} else {
					lis.first().attr('class', 'no2')
				}
				$('.no2').animate(json2, 400, function () {
					$('.no2').css(json2)
				})
			}
		}
	}
	function movePrev() {
		$('.none').css(lthide)
		if (!lis.is(':animated')) {
			var lt = $('.no0')
			var ct = $('.no1')
			var rt = $('.no2')
			if (!lis.is(':animated')) {
				lt.animate(json1, 400)
				ct.animate(json2, 400)
				rt.animate(rthdie, 400, function () {
					rt.css(json0)
					rt.attr('class', 'none')
				})
				ct.attr('class', 'no2')
				lt.attr('class', 'no1')
				if ($('.no1').prev().length != 0) {
					$('.no1').prev().attr('class', 'no0')
				} else {
					lis.last().attr('class', 'no0')
				}
				$('.no0').animate(json0, 400, function () {
					$('.no0').css(json0)
				})
			}
		}
	}
}

var bindSelectbank = function () {
	var bkacc_bkidEl = $('select[name=bkacc_bkid]') //中金-银行编号
	var provinceEl = $('select[name=bkacc_prccd]') //省份代码
	var cityEl = $('select[name=bkacc_citycd]') //城市代码
	var bkacc_prcnm = $('input[name=bkacc_prcnm]') //省份名称
	var bkacc_citynm = $('input[name=bkacc_citynm]') //城市名称
	var settlement_bank_name = $('select[name=settlement_bank_name]') //开户银行支行名称
	var settlement_bank_code = $('input[name=settlement_bank_code]') //支行联行号
	var DATA = {
		UBANKID: 102, //中金-银行编号，默认工商
		CITYCODE: 110100, //城市code，默认北京
	}
	var INIT = {
		bkacc_bkid: bkacc_bkidEl.data('id'),
		bkacc_prccd: provinceEl.data('id'),
		bkacc_citycd: cityEl.data('id'),
		settlement_bank_name: settlement_bank_name.data('id'),
	}
	getAccountSuppbank()
	getprovince()
	settlement_bank_name.on('change', function () {
		var bank_code = $(this).find('option:selected').data().fqhho2
		settlement_bank_code.val(bank_code)
	})
	provinceEl.on('change', function () {
		DATA.bkacc_prcnm = $(this).find('option:selected').text()
		bkacc_prcnm.val($(this).find('option:selected').text())
		var PROVID = $(this).find('option:selected').data().bkaccprccd
		getcitys(PROVID)
	})
	cityEl.on('change', function () {
		DATA.bkacc_citynm = $(this).find('option:selected').text()
		bkacc_citynm.val($(this).find('option:selected').text())
		DATA.CITYCODE = $(this).val()
		getpaybank()
	})
	bkacc_bkidEl.on('change', function () {
		DATA.UBANKID = $(this).val()
		getpaybank()
	})
	$('#checkCompany').click(function () {
		if ($('input[name=settlement_bank_account_number]').val() == '') {
			return layer.msg('请填写银行账号信息！')
		}
		var data = {
			cltacc_cltnm: $('input[name=settlement_bank_account_name]').val(), //户名(开户名称)
			bkacc_bkid: DATA.UBANKID, //银行编号(如:105)
			bkacc_accno: $('input[name=settlement_bank_account_number]').val(), //银行账号
		}
		_ajax('/pay/checkCompany', data, function (res) {
			if (res.code == 0) {
				DATA.srl_ptnsrl = res.srl_ptnsrl
				layer.open({
					title: '提示',
					content: '格利已向您填写的账户转入随机金额，请确认并填写打款金额！',
				})
				$('#checkCompany').addClass('_hide')
				var showel = ['#checkCompanyPlay', $('input[name=amount]').parent()]
				for (var i = 0; i < showel.length; i++) {
					$(showel[i]).removeClass('_hide')
				}
			} else {
				layer.open({
					title: '提示',
					content: res.rep_msg,
				})
			}
		})
	})
	$('input[name=amount]').focus(function () {
		layer.tips('请输入银行卡收到的金额！', $(this), {
			tips: [2, '#da241c'],
			anim: 5,
		})
	})
	$('#checkCompanyPlay').click(function () {
		var amount = $('input[name=amount]').val()
		if (!amount) {
			return layer.msg('请输入打款金额！')
		}
		var data = {
			amount: amount,
			srl_ptnsrl: DATA.srl_ptnsrl,
		}
		_ajax('/pay/checkCompanyPlay', data, function (res) {
			layer.open({
				title: '提示',
				content: res.rep_msg,
			})
			if (res.code == 0) {
				$('#checkCompanyPlay').addClass('_hide')
				$('.agree1_last_r').removeClass('_hide')
			}
		})
	})
	function getpaybank() {
		var data = {
			UBANKID: DATA.UBANKID,
			CITYCODE: DATA.CITYCODE,
		}
		_ajax('/pay/paybank', data, function (res) {
			var html = ''
			if (res.length != []) {
				settlement_bank_code.val(res[0].FQHHO2)
				for (var i = 0; i < res.length; i++) {
					var selected = ''
					if (res[i].FQHHO2 == INIT.settlement_bank_name) {
						selected = 'selected'
						settlement_bank_code.val(res[i].FQHHO2)
					} else {
						selected = ''
					}
					html +=
						'<option ' +
						selected +
						' value=' +
						res[i].FKHMC1 +
						' data-fqhho2=' +
						res[i].FQHHO2 +
						'>' +
						res[i].FKHMC1 +
						'</option>'
				}
			} else {
				html = "<option value=''>无此网点</option>"
			}
			settlement_bank_name.html(html)
		})
	}
	function getAccountSuppbank() {
		var html = ''
		var that = bkacc_bkidEl
		_ajax('/pay/getAccountSuppbank', '', function (res) {
			for (var i = 0; i < res.length; i++) {
				var selected = ''
				if (res[i].UBANKID == INIT.bkacc_bkid) {
					selected = 'selected'
					DATA.UBANKID = res[i].UBANKID
				} else {
					selected = ''
				}
				html +=
					'<option value=' +
					res[i].UBANKID +
					' ' +
					selected +
					'>' +
					res[i].BANKNAME +
					'</option>'
			}
			$(that).html(html)
		})
	}
	function getprovince() {
		var html = ''
		var that = provinceEl
		_ajax('/pay/provinces', '', function (res) {
			DATA.bkacc_prcnm = res[0].PROVNAME
			bkacc_prcnm.val(res[0].PROVNAME)
			for (var i = 0; i < res.length; i++) {
				var selected = ''
				if (res[i].PROVCODE == INIT.bkacc_prccd) {
					selected = 'selected'
					DATA.bkacc_prcnm = res[i].PROVNAME
					bkacc_prcnm.val(res[i].PROVNAME)
				} else {
					selected = ''
				}
				html +=
					'<option ' +
					selected +
					' value=' +
					res[i].PROVCODE +
					' data-bkaccPrccd=' +
					res[i].PROVID +
					'>' +
					res[i].PROVNAME +
					'</option>'
			}
			$(that).html(html)
			getcitys($(that).find('option:selected').data('bkaccprccd'))
		})
	}
	function getcitys(PROVID) {
		var html = ''
		var that = cityEl
		_ajax('/pay/citys', { PROVID: PROVID }, function (res) {
			DATA.bkacc_citynm = res[0] ? res[0].CITYNAME : ''
			bkacc_citynm.val(res[0] ? res[0].CITYNAME : '')
			DATA.CITYCODE = res[0] ? res[0].CITYCODE : ''
			for (var i = 0; i < res.length; i++) {
				var selected = ''
				if (res[i].CITYCODE == INIT.bkacc_citycd) {
					selected = 'selected'
					DATA.bkacc_citynm = res[i].CITYNAME
					bkacc_citynm.val(res[i].CITYNAME)
					DATA.CITYCODE = res[i].CITYCODE
				} else {
					selected = ''
				}
				html +=
					'<option value=' +
					res[i].CITYCODE +
					' ' +
					selected +
					'>' +
					res[i].CITYNAME +
					'</option>'
			}
			$(that).html(html)
			getpaybank()
		})
	}
	function _ajax(url, data, cb) {
		$.ajax({
			type: 'post',
			url: jkas.url(url),
			data: data,
			dataType: 'json',
			success: function (res) {
				cb(res)
			},
		})
	}
}

$(function () {
	var phtml = `<select name="bkacc_prcnm" class="bkacc_prcnm" style="width: 120px;" >`
	var phtml_qy = `<select name="bkacc_prcnm_qy" class="bkacc_prcnm_qy" style="width: 120px;" >`
	// 全屏点击隐藏ul
	$(document).click(function (event) {
		var _con = $('.dnmd');   // 设置目标区域
		if (!_con.is(event.target) && _con.has(event.target).length === 0) {
			$('.zh_search_box').hide(100);          //淡出消失
		}
	})
	// 全屏点击隐藏ul
	$(document).click(function (event) {
		var _con = $('.dnmd');   // 设置目标区域
		if (!_con.is(event.target) && _con.has(event.target).length === 0) {
			$('.zh_search_box_qy').hide(100);          //淡出消失
		}
	})
	// 支行名称input变化
	$(".bkacc_openbknm").on("input propertychange", function () {
		$('#bkacc_openbkcd').val('')
		$('#bkacc_openbkcd').show()
		getPaybank()
	})

	$(".bkacc_openbknm").focus(function () {
		$('#bkacc_openbkcd').val('')
		$('#bkacc_openbkcd').show()
		getPaybank()
	})
	// 支行名称input变化
	$(".bkacc_openbknm_qy").on("input propertychange", function () {
		$('#bkacc_openbkcd_qy').val('')
		$('#bkacc_openbkcd_qy').show()
		getPaybank_qy()
	})

	$(".bkacc_openbknm_qy").focus(function () {
		$('#bkacc_openbkcd_qy').val('')
		$('#bkacc_openbkcd_qy').show()
		getPaybank_qy()
	})

	// 设置银行卡类型
	$.ajax({
		url: jkas.url('/wxxcx/getAccountSuppbank'),
		type: 'post',
		success: function (res) {
			var q = JSON.parse(res)
			if (q.code == 10) {
				var html = `<select name="bkacc_bkid" id="bkacc_bkid" style="width: 260px;" >`
				var html_qy = `<select name="bkacc_bkid" id="bkacc_bkid_qy" style="width: 260px;" >`
				for (let i = 0; i < q.data.length; i++) {
					html += '<option name="bkacc_bkid" value="' + q.data[i].UBANKID + '">' + q.data[i].BANKNAME + '</option>'
					html_qy += '<option name="bkacc_bkid" value="' + q.data[i].UBANKID + '">' + q.data[i].BANKNAME + '</option>'
				}
				html += `</select >`
				html_qy += `</select >`
				$('.yhklx').append(html)
				$('.yhklx_qy').append(html_qy)
			}
		}
	})

	// 设置省
	getProvinces()

	// 设置市
	getCtity(2)

	function getProvinces() {
		$.ajax({
			url: jkas.url('/wxxcx/bankProvinces'),
			type: 'post',
			success: function (res) {
				var q = JSON.parse(res)
				if (q.code == 10) {
					for (let i = 0; i < q.data.length; i++) {
						phtml += '<option name="bkacc_prccd"' + (i == 0 ? 'selected ' : '') + 'value="' + q.data[i].PROVID + '">' + q.data[i].PROVNAME + '</option>'
						phtml_qy += '<option name="bkacc_prccd_qy"' + (i == 0 ? 'selected ' : '') + 'value="' + q.data[i].PROVID + '">' + q.data[i].PROVNAME + '</option>'
					}
					phtml += `</select >`
					phtml_qy += `</select >`
					$('.khzh').append(phtml)
					$('.khzh_qy').append(phtml_qy)
					// 省变化
					$('.bkacc_prcnm').change(function () {
						getCtity($(this).children('option:selected').val())
					})
					$('.bkacc_prcnm_qy').change(function () {
						getCtity($(this).children('option:selected').val())
					})
				}
			}
		})
	}

	function getCtity(PROVID) {
		$.ajax({
			url: jkas.url('/wxxcx/bankCitys'),
			type: 'post',
			data: { PROVID: PROVID },
			success: function (res) {
				var q = JSON.parse(res)
				var html = `<select name="bkacc_citynm" class="bkacc_citynm" style="width: 120px;" >`
				var html_qy = `<select name="bkacc_citynm_qy" class="bkacc_citynm_qy" style="width: 120px;" >`
				if (q.code == 10) {
					for (let i = 0; i < q.data.length; i++) {
						html += '<option name="bkacc_citycd" data-val="' + q.data[i].CITYCODE + '"' + (i == 0 ? 'selected ' : '') + 'value="' + q.data[i].CITYID + '">'
							+ q.data[i].CITYNAME +
							'</option>'
						html_qy += '<option name="bkacc_citycd" data-val="' + q.data[i].CITYCODE + '"' + (i == 0 ? 'selected ' : '') + 'value="' + q.data[i].CITYID + '">'
							+ q.data[i].CITYNAME +
							'</option>'
					}
					html += `</select>`
					html_qy += `</select>`
					$('.bkacc_citynm').remove()
					$('.bkacc_citynm_qy').remove()
					$('.khzh').append(html)
					$('.khzh_qy').append(html_qy)
				}
			}
		})
	}
	// 获取开户行
	function getPaybank(PROVID) {
		getUlChange()

		$.ajax({
			url: jkas.url('/wxxcx/paybank'),
			type: 'post',
			data: {
				UBANKID: $('#bkacc_bkid').val() || '',
				CITYCODE: $('.bkacc_citynm').children('option:selected').data('val') || '',
				keywords: $('.bkacc_openbknm').val() || ''
			},
			success: function (res) {
				var q = JSON.parse(res)
				var html = ''
				if (q.code == 10) {
					for (var i = 0; i < q.data.length; i++) {
						html += `<li data-val="` + q.data[i].FQHHO2 + `">` + q.data[i].FKHMC1 + `</li> `
					}
					$('.zh_list').html(html);
					$('.zh_search_box').show()

					getUlChange()
				}
			}
		})
	}
	// 获取开户行
	function getPaybank_qy(PROVID) {
		getUlChange_qy()

		$.ajax({
			url: jkas.url('/wxxcx/paybank'),
			type: 'post',
			data: {
				UBANKID: $('#bkacc_bkid').val() || '',
				CITYCODE: $('.bkacc_citynm_qy').children('option:selected').data('val') || '',
				keywords: $('.bkacc_openbknm_qy').val() || ''
			},
			success: function (res) {
				var q = JSON.parse(res)
				var html = ''
				if (q.code == 10) {
					for (var i = 0; i < q.data.length; i++) {
						html += `<li data-val="` + q.data[i].FQHHO2 + `">` + q.data[i].FKHMC1 + `</li> `
					}
					$('.zh_list_qy').html(html);
					$('.zh_search_box_qy').show()

					getUlChange_qy()
				}
			}
		})
	}

	function getUlChange() {
		// 市变化
		$("ul.zh_list").on("click", "li", function () {      //只需要找到你点击的是哪个ul里面的就行
			$('.bkacc_openbknm').val($(this).text())
			$('#bkacc_openbkcd').val($(this).data('val'))
			$('.zh_search_box').hide(100)
		});
	}
	function getUlChange_qy() {
		// 市变化
		$("ul.zh_list_qy").on("click", "li", function () {      //只需要找到你点击的是哪个ul里面的就行
			$('.bkacc_openbknm_qy').val($(this).text())
			$('#bkacc_openbkcd_qy').val($(this).data('val'))
			$('.zh_search_box_qy').hide(100)
		});
	}


	// 1 国内 2海外
	if (getUrlSearch('type') == 1) {
		$('.pay').show()
		$('.txzl').show()
		$('.hwdzd').hide()
		$('.tjzl').hide()
		$('#country').html('<option value="">请选择</option><option value = "1" >中国</option >')
	} else {
		$('.pay').hide()
		$('.txzl').hide()
		$('.hwdzd').show()
		$('.tjzl').show()
		$('.step_box').attr('style', 'margin-left: 260px;')
		$('.hwptzy').attr('style', 'left: 485px;')
		$('#country').html('<option value="">请选择</option><option value = "0" >海外</option>')
	}

	// 账户类型
	$('.c1_gr').click(function () {
		$(this).parents('.agree_wapper').hide()
		$(this).parents('.agree_wapper').next().css('display', 'block')
		$('.grsk').show()
		$('.qysk').hide()
	})

	$('.c2_qy').click(function () {
		$(this).parents('.agree_wapper').hide()
		$(this).parents('.agree_wapper').next().css('display', 'block')
		$('.qysk').show()
		$('.grsk').hide()
	})

})
